<template>
    <div>

        <c-panel v-if="loading">
            <div class="loading-form" style="min-height: 270px;">
                <img src="/public/img/loading-bar.gif" />
            </div>
        </c-panel>

        <el-form v-if="!loading" @submit.native.prevent="onSubmit" :model="dados" ref="dados" label-position="top">

            <c-panel title="FICHA DE SAÚDE DO ALUNO" titleIcon="fas fa-notes-medical">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="16" :md="16">
                        <dl>
                            <dt>ALUNO</dt>
                            <dd style="text-transform: uppercase;">
                                {{ aluno.nome_social_aluno ? aluno.nome + ' – ' + aluno.nome_social_aluno : aluno.nome }}
                            </dd>
                        </dl>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <dl>
                            <dt>MATRÍCULA</dt>
                            <dd>{{ aluno.num_matricula ? aluno.num_matricula : '-' }}</dd>
                        </dl>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="IDENTIFICAÇÃO / MEDIDAS" titleIcon="fas fa-id-card">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Tipo sanguíneo" prop="tipo_sanguineo">
                            <el-select v-model="dados.tipo_sanguineo" clearable>
                                <el-option label="A" value="A"></el-option>
                                <el-option label="B" value="B"></el-option>
                                <el-option label="AB" value="AB"></el-option>
                                <el-option label="O" value="O"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Fator RH" prop="fator_rh">
                            <el-select v-model="dados.fator_rh" clearable>
                                <el-option label="+" value="+"></el-option>
                                <el-option label="-" value="-"></el-option>
                            </el-select>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Peso (kg)" prop="peso">
                            <el-input v-model="dados.peso" placeholder="Ex.: 32.50"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Altura (m)" prop="altura">
                            <el-input v-model="dados.altura" placeholder="Ex.: 1.28"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="ALERGIAS / RESTRIÇÕES" titleIcon="fas fa-allergies">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Possui alergias?" prop="possui_alergias">
                            <el-switch v-model="dados.possui_alergias"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Descrição das alergias" prop="alergias_descricao" v-if="dados.possui_alergias">
                            <el-input type="textarea" :rows="3" v-model="dados.alergias_descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Restrição alimentar?" prop="restricao_alimentar">
                            <el-switch v-model="dados.restricao_alimentar"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Descrição da restrição alimentar" prop="restricao_alimentar_descricao" v-if="dados.restricao_alimentar">
                            <el-input type="textarea" :rows="3" v-model="dados.restricao_alimentar_descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="CONDIÇÕES DE SAÚDE" titleIcon="fas fa-heartbeat">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Possui doença crônica?" prop="possui_doenca_cronica">
                            <el-switch v-model="dados.possui_doenca_cronica"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Descrição das doenças crônicas" prop="doencas_cronicas_descricao" v-if="dados.possui_doenca_cronica">
                            <el-input type="textarea" :rows="3" v-model="dados.doencas_cronicas_descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Asma" prop="asma">
                            <el-switch v-model="dados.asma"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Diabetes" prop="diabetes">
                            <el-switch v-model="dados.diabetes"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Epilepsia" prop="epilepsia">
                            <el-switch v-model="dados.epilepsia"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="CID-10 (se houver)" prop="cid10">
                            <el-input v-model="dados.cid10" maxlength="20"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="MEDICAÇÃO" titleIcon="fas fa-pills">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Usa medicação contínua?" prop="usa_medicacao_continua">
                            <el-switch v-model="dados.usa_medicacao_continua"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Medicações (nome/dose/horário)" prop="medicacoes_descricao" v-if="dados.usa_medicacao_continua">
                            <el-input type="textarea" :rows="3" v-model="dados.medicacoes_descricao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Autorizado administrar medicação na escola?" prop="autorizado_medicacao_na_escola">
                            <el-switch v-model="dados.autorizado_medicacao_na_escola"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="16" :md="16">
                        <el-form-item label="Orientações para administração" prop="orientacoes_medicacao" v-if="dados.autorizado_medicacao_na_escola">
                            <el-input type="textarea" :rows="3" v-model="dados.orientacoes_medicacao"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="VACINAÇÃO / REDE DE SAÚDE" titleIcon="fas fa-syringe">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Vacinas em dia?" prop="vacinas_em_dia">
                            <el-switch v-model="dados.vacinas_em_dia"></el-switch>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Atualização da caderneta" prop="data_atualizacao_caderneta" :rules="[validateDataOptional]">
                            <el-input v-model="dados.data_atualizacao_caderneta" v-mask="'##/##/####'" placeholder="dd/mm/aaaa"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Possui plano de saúde?" prop="possui_plano_saude">
                            <el-switch v-model="dados.possui_plano_saude"></el-switch>
                        </el-form-item>
                    </el-col>
                </el-row>
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Plano (nome)" prop="plano_saude_nome" v-if="dados.possui_plano_saude">
                            <el-input v-model="dados.plano_saude_nome" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Unidade de saúde de referência" prop="unidade_saude_referencia">
                            <el-input v-model="dados.unidade_saude_referencia" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="8" :md="8">
                        <el-form-item label="Hospital de referência" prop="hospital_referencia">
                            <el-input v-model="dados.hospital_referencia" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="CONTATO DE EMERGÊNCIA" titleIcon="fas fa-phone-alt">
                <el-row :gutter="10">
                    <el-col :xs="24" :sm="10" :md="10">
                        <el-form-item label="Nome do contato *" prop="contato_emergencia_nome" :rules="[$requiredBlur]">
                            <el-input v-model="dados.contato_emergencia_nome" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="6" :md="6">
                        <el-form-item label="Parentesco" prop="contato_emergencia_parentesco">
                            <el-input v-model="dados.contato_emergencia_parentesco" maxlength="191"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Telefone 1 *" prop="contato_emergencia_telefone1" :rules="[$requiredBlur]">
                            <el-input v-model="dados.contato_emergencia_telefone1" v-mask="'(##) #########'" maxlength="15"></el-input>
                        </el-form-item>
                    </el-col>
                    <el-col :xs="24" :sm="4" :md="4">
                        <el-form-item label="Telefone 2" prop="contato_emergencia_telefone2">
                            <el-input v-model="dados.contato_emergencia_telefone2" v-mask="'(##) #########'" maxlength="15"></el-input>
                        </el-form-item>
                    </el-col>
                </el-row>
            </c-panel>

            <c-panel title="OBSERVAÇÕES" titleIcon="fas fa-sticky-note">
                <el-form-item label="Observações gerais" prop="observacoes">
                    <el-input type="textarea" :rows="4" v-model="dados.observacoes"></el-input>
                </el-form-item>
            </c-panel>

            <div class="u-text-right u-mt-10">
                <el-button id="btn-ficha-saude" :loading="saving" type="primary" native-type="submit">SALVAR</el-button>
            </div>
        </el-form>
    </div>
</template>

<script>
export default {
    props: ['alunoId'],
    data: () => ({
        loading: false,
        saving: false,
        aluno: {},
        dados: {
            id: '',
            aluno_id: '',
            tipo_sanguineo: '',
            fator_rh: '',
            peso: '',
            altura: '',
            possui_alergias: false,
            alergias_descricao: '',
            restricao_alimentar: false,
            restricao_alimentar_descricao: '',
            possui_doenca_cronica: false,
            doencas_cronicas_descricao: '',
            asma: false,
            diabetes: false,
            epilepsia: false,
            cid10: '',
            usa_medicacao_continua: false,
            medicacoes_descricao: '',
            autorizado_medicacao_na_escola: false,
            orientacoes_medicacao: '',
            vacinas_em_dia: false,
            data_atualizacao_caderneta: '',
            unidade_saude_referencia: '',
            hospital_referencia: '',
            possui_plano_saude: false,
            plano_saude_nome: '',
            contato_emergencia_nome: '',
            contato_emergencia_parentesco: '',
            contato_emergencia_telefone1: '',
            contato_emergencia_telefone2: '',
            observacoes: ''
        }
    }),
    methods: {
        validateDataOptional (rule, value, callback) {
            if (!value) return callback()
            const ok = this.$moment(value, 'DD/MM/YYYY', true).isValid()
            return ok ? callback() : callback(new Error('Data inválida. Use dd/mm/aaaa.'))
        },
        async loadAll () {
            this.loading = true
            try {
                const alunoId = this.alunoId

                const resAluno = await this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/aluno/getByIdForInfo/${alunoId}`,
                    this.$store.getters.getHeaderAuth
                )
                this.aluno = resAluno.data || {}

                const resFicha = await this.$axios.get(
                    `${this.$store.state.config.baseUrlApi}/api/aluno/ficha-saude/getByAlunoId/${alunoId}`,
                    this.$store.getters.getHeaderAuth
                )

                if (resFicha.data) {
                    this.dados = Object.assign({}, this.dados, resFicha.data)
                    // normaliza data para dd/mm/yyyy no input
                    if (this.dados.data_atualizacao_caderneta) {
                        this.dados.data_atualizacao_caderneta = this.$moment(this.dados.data_atualizacao_caderneta).format('DD/MM/YYYY')
                    }
                } else {
                    this.dados.aluno_id = alunoId
                }
            } catch (error) {
                this.$store.commit('throwException', error)
            } finally {
                this.loading = false
            }
        },
        onSubmit () {
            document.getElementById('btn-ficha-saude').focus()
            this.$refs.dados.validate(async (valid) => {
                if (!valid) return window.eventBus.$emit('alert', { msg: 'Campos obrigatórios não foram preenchidos.', type: 'warning' })
                this.saving = true
                window.eventBus.$emit('loading', true)
                try {
                    const alunoId = this.alunoId
                    const payload = JSON.parse(JSON.stringify(this.dados))
                    const res = await this.$axios.post(
                        `${this.$store.state.config.baseUrlApi}/api/aluno/ficha-saude/storeOrUpdate/${alunoId}`,
                        payload,
                        this.$store.getters.getHeaderAuth
                    )
                    this.dados = Object.assign({}, this.dados, res.data || {})
                    window.eventBus.$emit('alert', { msg: 'Sucesso! Ficha de saúde salva.', type: 'success' })
                    this.$router.push(`/admin/aluno`);
                } catch (error) {
                    this.$store.commit('throwException', error)
                } finally {
                    window.eventBus.$emit('loading', false)
                    this.saving = false
                }
            })
        }
    },
    watch: {
        alunoId: {
            immediate: true,
            handler (value) {
                if (value) this.loadAll()
            }
        }
    }
}
</script>

